var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertSign = function SvgAlertSign(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8e5fe;}.cls-2,.cls-3{fill:#8075f2;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-alert-sign"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.5591,3.4409A11.4815,11.4815,0,0,1,3.4409,19.5591,11.487,11.487,0,1,0,19.5591,3.4409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,0A12.5,12.5,0,1,0,25,12.5,12.5,12.5,0,0,0,12.5,0Zm0,24A11.5,11.5,0,1,1,24,12.5,11.5129,11.5129,0,0,1,12.5,24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12,
    y: 8,
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12,
    y: 16,
    width: 1,
    height: 1
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-sign.828d3e1cea3762ee9ed52834fbb38711.svg";